import { call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';
import {
    getAnnotationErrorMessage,
    getAnnotationErrorTitle,
    isAnnotationFailure,
} from 'services/annotations';

function notifyAnnotationError(response) {
    return put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: getAnnotationErrorTitle(response),
            message: getAnnotationErrorMessage(response),
            level: 'error',
            _id: new Date().getMilliseconds(),
            autoDismiss: 99999,
        },
    });
}

/**
 * Get annotations by text
 * */
export function* postAnnotations(text, typeLetter, selectedServer, options) {
    const response = yield call(api.postAnnotations, text, typeLetter, selectedServer, options);

    if (!isAnnotationFailure(response)) {
        yield put({
            type: actionTypes.POST_ANNOTATIONS.SUCCESS,
            data: response.data.annotations,
            headers: response.headers,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Annotations obtain',
                level: 'success',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.POST_ANNOTATIONS.FAILURE,
    });

    yield notifyAnnotationError(response);

    return response;
}

export function* watchPostAnnotations() {
    while (true) {
        const { text, typeLetter, selectedServer, options } = yield take(actionTypes.POST_ANNOTATIONS.REQUEST);

        try {
            yield call(postAnnotations, text, typeLetter, selectedServer, options);
        } catch (error) {
            console.dir(error);

            yield put({
                type: actionTypes.POST_ANNOTATIONS.FAILURE,
            });

            yield notifyAnnotationError(error);
        }
    }
}

export default [
    watchPostAnnotations,
];



// WEBPACK FOOTER //
// ./app/sagas/annotations.js